const routes = [
  {
    path: '',
    component: () =>
      import('@/views/provider/service-satisfaction-questionnaire/Wrapper.vue'),
    children: [
      {
        path: '/provider/service-satisfaction-questionnaire',
        name: 'ServiceSatisfactionQuestionnaire',
        component: () =>
          import(
            '@/views/provider/service-satisfaction-questionnaire/Main.vue'
          ),
      },
      {
        path: '/provider/service-satisfaction-questionnaire/sample-details',
        name: 'ServiceSatisfactionQuestionnaireSampleDetails',
        props: true,
        component: () =>
          import(
            '@/views/provider/service-satisfaction-questionnaire/SampleDetails.vue'
          ),
      },
    ],
  },
];

export default routes;
